const en: Record<string, string> = {
  'nav.blog': 'Blog',
  'nav.virtualOffice': 'Virtual Office',
  'nav.coworking': 'Coworking',
  'nav.accounting': 'Accounting & Legal',
  'nav.contact': 'Contact',
  'nav.clientPortal': 'Client Portal',
  'nav.getStarted': 'Get Started',
  'nav.menu': 'Navigation menu',
  'hero.badge': 'Trusted by 400+ companies from 7 countries',
  'hero.title1': 'Virtual office in Belgrade',
  'hero.title2': 'for foreign and domestic companies',
  'hero.title3': '',
  'hero.desc': 'Opening or relocating a company to Serbia and unsure whether your address is compliant and will pass at the APR? You get a 100% legal business address, registration and administration, fully compliant with Serbian law and active within 48h of signing.',
  'hero.trust1': 'Business address in Belgrade and Kovin (Pančevo tax office); Loznica coming soon, express interest',
  'hero.trust2': 'Help with opening a company in Serbia',
  'hero.trust3': 'Mail receipt and forwarding',
  'hero.trust4': 'Accounting and administrative support',
  'hero.cta1': 'Start doing business in Serbia today',
  'hero.cta2': 'How It Works',
  'hero.reviews': 'from 180+ verified client reviews',
  'hero.clientPortal': 'Client Portal',
  'hero.active': 'Active',
  'hero.documents': 'Documents',
  'hero.invoices': 'Invoices',
  'hero.plan': 'Plan',
  'hero.address': 'Address',
  'hero.liveActivity': 'Live Activity',
  'hero.docUploaded': 'New document uploaded',
  'hero.invoicePaid': 'Invoice paid',
  'hero.mailForwarded': 'Mail forwarded',
  'hero.newClients': '12 new clients',
  'hero.thisMonth': 'This month',
  'hero.mockCompany': 'EVI Solutions DOO',
  'hero.activityCompany1': 'Tehno sistem d.o.o.',
  'hero.activityCompany2': 'Jadran trade d.o.o.',
  'hero.activityCompany3': 'Stojanović consulting d.o.o.',
  'hero.timeAgo2m': '2m ago',
  'hero.timeAgo18m': '18m ago',
  'hero.timeAgo1h': '1h ago',
  'hero.kpi.documentsSub': '2 new this week',
  'hero.kpi.invoicesSub': '1 pending payment',
  'hero.kpi.planSub': 'Virtual Office',
  'hero.kpi.addressValue': 'Belgrade',
  'hero.kpi.addressSub': 'Topčiderska 14',
  'services.tag': 'What We Offer',
  'services.title': 'Business Address, Mail Handling and\nAccounting in One Place',
  'services.desc':
    'Whether you are a foreign company establishing a Serbian presence or a local entrepreneur, Top14 office solutions cover registration, your address, and ongoing support.',
  'services.mostPopular': 'Most Popular',
  'services.virtualOffice.tag': 'Business Address & Registration',
  'services.virtualOffice.title': 'Virtual Office',
  'services.virtualOffice.desc':
    'Registered business addresses in Belgrade (Topčiderska) and Kovin (Pančevo tax office). The Loznica location is coming soon, express interest. Includes mail handling, company registration support and a secure document portal.',
  'services.virtualOffice.taxNote':
    'Alternative locations may support further tax optimisation depending on your business model.',
  'services.virtualOffice.f1': 'Belgrade – Topčiderska, Savski venac municipality',
  'services.virtualOffice.f5': 'Kovin, Pančevo tax office - most favourable flat tax in Serbia',
  'services.virtualOffice.f6': 'Loznica, coming soon, near BiH border (express interest)',
  'services.virtualOffice.f2': 'APR registration support',
  'services.virtualOffice.f3': 'Suitable for foreign companies',
  'services.virtualOffice.f4': 'Document management portal',
  'services.virtualOffice.price': '3,500 RSD',
  'services.virtualOffice.per': '/ month (~30 EUR)',
  'services.virtualOffice.learn': 'Learn more',
  'services.coworking.tag': 'Flexible Workspace',
  'services.coworking.title': 'Coworking Space',
  'services.coworking.desc': 'Modern desks and private offices in central Belgrade. Gigabit 1 Gbps internet, 3 meeting rooms and a quiet space with a maximum of 20 users.',
  'services.coworking.price': '€89',
  'services.coworking.per': '/ month',
  'services.coworking.plans': 'View plans',
  'services.accounting.tag': 'Business Support',
  'services.accounting.title': 'Accounting & Legal',
  'services.accounting.desc': 'Bookkeeping, VAT registration, tax returns and legal consulting - in Serbian, English, Russian, Turkish and German.',
  'services.accounting.cta': 'Free consultation',
  'capitaale.aria': 'Recommended app for flat-tax entrepreneurs',
  'capitaale.tag': 'Recommended for flat-tax entrepreneurs',
  'capitaale.desc':
    'Capitaale is an app for entrepreneurs who invoice clients abroad. Real RSD balance after the bank rate, live flat-tax limit tracking, a warning when one client exceeds 70% of revenue, and an invoice in EUR or USD in 60 seconds. First 7 days free.',
  'capitaale.cta': 'Try 7 days free',
  'capitaale.external': 'Opens Capitaale partner page',
  'how.tag': 'Step by Step',
  'how.title': 'How You Launch Business in Serbia With Us',
  'how.desc':
    'We guide you through the entire journey, from first idea to a fully operational company, without complications or wasted time.',
  'how.step1.title': 'Short consultation call',
  'how.step1.lead': 'We learn your needs and recommend the best solution',
  'how.step1.desc':
    'We discuss your business, goals, and scope of activity in Serbia, then propose the optimal service package.',
  'how.step1.badge': '15–30 min',
  'how.step2.title': 'Proposal & agreement',
  'how.step2.lead': 'You get a clear plan and all terms upfront',
  'how.step2.desc':
    'We send a concrete service proposal and a sample contract. Everything is transparent, with no hidden costs.',
  'how.step2.check1': 'clearly defined',
  'how.step2.check2': 'minimal bureaucracy',
  'how.step3.title': 'Business address consent',
  'how.step3.lead': 'You get permission to use our address as your registered seat',
  'how.step3.intro': 'From us you receive:',
  'how.step3.bullet1': 'consent to register our address with the APR',
  'how.step3.bullet2': 'the documents needed for the company seat',
  'how.step3.bullet3': 'mail receipt at that address',
  'how.step3.badge': 'typically a few days',
  'how.step4.title': 'Activation & work in the portal',
  'how.step4.lead': 'Everything else is handled in one place',
  'how.step4.desc': 'After signing, we open your account on our portal where you can:',
  'how.step4.bullet1': 'manage documents',
  'how.step4.bullet2': 'communicate with the team',
  'how.step4.bullet3': 'track invoices and services',
  'how.step4.badge': '24/7 support',
  'how.cta': 'Start your business without complications',
  'how.learnMore': 'Learn More',
  'vo.tag': 'Virtual Office',
  'vo.title': 'Professional Belgrade\nAddress for Your Business',
  'vo.desc': 'Registered address on Topčiderska Street, Belgrade - perfect for foreign companies entering the Serbian market.',
  'vo.standard': 'Standard',
  'vo.premium': 'Premium',
  'vo.popular': 'Most Popular',
  'vo.month': '/ month',
  'vo.getStarted': 'Get Started',
  'vo.contact': 'Contact Us',
  'vo.included': 'Included in all plans',
  'cw.tag': 'Coworking Space',
  'cw.title': 'Modern Workspaces\nin Central Belgrade',
  'cw.desc': 'Flexible coworking spaces designed for productivity. From hot desk options to private offices - find the perfect space for your team.',
  'cw.hotDesk': 'Hot Desk',
  'cw.dedicatedDesk': 'Dedicated Desk',
  'cw.privateOffice': 'Private Office',
  'cw.month': '/ month',
  'cw.getStarted': 'Get Started',
  'cw.bookTour': 'Book a Tour',
  'acc.tag': 'Accounting & Legal',
  'acc.title': 'Complete Financial & Legal\nSupport for Your Business',
  'acc.desc': 'Our team of experienced accountants and legal advisors provides comprehensive support for companies operating in Serbia.',
  'acc.basic': 'Basic',
  'acc.professional': 'Professional',
  'acc.enterprise': 'Enterprise',
  'acc.month': '/ month',
  'acc.getStarted': 'Get Started',
  'acc.consultation': 'Free consultation',
  'acc.pricing.title': 'Accounting Services Pricing',
  'acc.pricing.subtitle': 'All prices are in Serbian Dinars (RSD). Prices are minimum and subject to agreement.',
  'acc.pricing.service': 'Service',
  'acc.pricing.clientPrice': 'Client Price',
  'acc.pricing.regularPrice': 'Regular Price',
  'acc.pricing.unit': 'Unit / note',
  'acc.pricing.online': 'Online',
  'trust.tag': 'Why Top14',
  'trust.title': 'Trusted by Companies\nAround the World',
  'trust.desc':
    'More than 400 companies from 7 countries choose Top14 office solutions for their business presence in Serbia.',
  'trust.companies': 'Active Companies',
  'trust.countries': 'Countries',
  'trust.years': 'Years of Experience',
  'trust.satisfaction': 'Client Satisfaction',
  'contact.tag': 'Get in Touch',
  'contact.title': 'Top14 office solutions',
  'contact.desc': 'Ready to establish your Serbian business presence? Send us a message and our team will respond within one business day.',
  'contact.address': 'Address',
  'contact.phone': 'Phone',
  'contact.email': 'Email',
  'contact.hours': 'Business Hours',
  'contact.hoursValue': 'Mon–Fri, 09:00–17:00 CET',
  'contact.addressValue': 'Topčiderska 14, 11000 Belgrade, Serbia',
  'contact.phoneValue': '+381 62 262 221',
  'contact.emailValue': 'office@top14.rs',
  'contact.mapStreet': 'Topčiderska street',
  'contact.mapCity': 'Belgrade, Serbia',
  'contact.responseTime': 'Typical Response Time',
  'contact.responseValue': 'Under 4 hours during business hours',
  'contact.weRespond': 'We respond in',
  'contact.formTitle': 'Send Us a Message',
  'contact.formDesc': 'We will respond within one business day.',
  'contact.name': 'Full Name *',
  'contact.emailField': 'Email Address *',
  'contact.phoneField': 'Phone number to reach you *',
  'contact.placeholderPhone': '+381 60 123 4567',
  'contact.errPhone': 'Please enter your phone number.',
  'contact.company': 'Company Name',
  'contact.country': 'Country',
  'contact.officeLocation': 'Virtual office location *',
  'contact.selectOfficeLocation': 'Select a location…',
  'contact.location.belgrade': 'Belgrade, Topčiderska - Savski venac tax office',
  'contact.location.kovinPancevo': 'Kovin - Pančevo tax office (most favourable flat tax in Serbia)',
  'contact.location.loznica': 'Loznica, coming soon (near BiH); express interest',
  'contact.location.arandjelovac': 'Aranđelovac',
  'contact.errOfficeLocation': 'Please select an office location.',
  'contact.service': 'Services of Interest *',
  'contact.selectService': 'Select a service...',
  'contact.placeholderName': 'Jane Smith',
  'contact.placeholderEmail': 'jane@company.com',
  'contact.placeholderCompany': 'Example Ltd.',
  'contact.placeholderCountry': 'Germany',
  'contact.placeholderMessage':
    'We are looking for a virtual office in Belgrade and help registering a branch office. Please outline the steps and approximate pricing.',
  'contact.serviceRequired': 'Select at least one service.',
  'contact.errName': 'Please enter your name.',
  'contact.errEmail': 'Please enter your email.',
  'contact.errEmailInvalid': 'Please enter a valid email address.',
  'contact.errMessage': 'Please enter your message.',
  'contact.errMessageMin': 'Message must be at least 20 characters.',
  'contact.message': 'Message *',
  'contact.messageHint': 'Describe your business needs and specific questions.',
  'contact.send': 'Send Message',
  'contact.sending': 'Sending...',
  'contact.successTitle': 'Message Sent',
  'contact.successDesc': 'Thank you for reaching out. Our team will contact you within one business day.',
  'contact.sendAnother': 'Send Another Message',
  'contact.services.vo': 'Virtual Office',
  'contact.services.cw': 'Coworking Space',
  'contact.services.acc': 'Accounting & Legal Support',
  'contact.services.reg': 'Company Registration',
  'contact.services.gen': 'General Inquiry',
  'contact.toast': 'Message sent! We will get back to you within one business day.',
  'contact.errorSend': 'Could not send your message. Please try again in a moment.',
  'footer.desc':
    'Top14 - professional virtual office, coworking, and business support for companies operating in Serbia.',
  'footer.services': 'Services',
  'footer.company': 'Company',
  'footer.contact': 'Contact',
  'footer.about': 'About us',
  'footer.howItWorks': 'How It Works',
  'footer.pricing': 'Pricing',
  'footer.clientPortal': 'Client Portal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.cookies': 'Cookie Policy',
  'legal.backHome': 'Back to home',
  'footer.rights': '© 2026 EVI Solutions DOO. All rights reserved.',
  'portal.adminDashboard': 'Admin Dashboard',
  'portal.operatorDashboard': 'Operator Dashboard',
  'portal.roleBadgeAdmin': 'Administrator',
  'portal.roleBadgeOperator': 'Operator',
  'portal.roleBadgeClient': 'Client',
  'portal.clientDashboard': 'Client Dashboard',
  'portal.signOut': 'Sign Out',
  'portal.publicSite': 'Public Site',
  'portal.settings': 'Settings',
  'portal.password.title': 'Change password',
  'portal.password.hint': 'For accounts that sign in with email and password.',
  'portal.password.current': 'Current password',
  'portal.password.new': 'New password',
  'portal.password.confirm': 'Confirm new password',
  'portal.password.submit': 'Update password',
  'portal.password.saving': 'Updating…',
  'portal.password.changed': 'Password updated successfully.',
  'portal.password.wrongCurrent': 'Current password is incorrect.',
  'portal.password.mismatch': 'New passwords do not match.',
  'portal.password.tooShort': 'Password must be at least 8 characters.',
  'portal.password.changeFailed': 'Could not update password.',
  'portal.password.noEmail': 'No email on this account.',
  'portal.darkMode': 'Dark mode',
  'portal.notifications': 'Notifications',
  'portal.markAllRead': 'Mark all as read',
  'portal.viewAll': 'View all',
  'portal.notificationsPageTitle': 'Notifications',
  'portal.notificationsUnreadHint': 'unread',
  'portal.notificationsAllCaughtUp': 'All caught up',
  'portal.notificationsEmpty': 'No notifications yet.',
  'portal.notificationsLoadError': 'Could not load notifications.',
  'portal.markAllReadDone': 'Everything marked as read.',
  'portal.notificationsNeedCompany': 'Notifications will appear once your company is loaded.',
  'portal.notif.contactForm': 'New contact form message: {{name}}',
  'portal.notif.newTask': 'New task request',
  'portal.profile': 'Profile',
  'portal.search': 'Search companies, documents...',
  'portal.company': 'Company',
  'portal.contactSupport': 'Contact Support',
  'portal.exportReport': 'Export Report',
  'portal.addCompany': 'Add Company',
  'portal.language': 'Language',
  'portal.openMenu': 'Open menu',
  'sidebar.main': 'Navigation',
  'sidebar.dashboard': 'Dashboard',
  'sidebar.myCompany': 'My Company',
  'sidebar.companies': 'Companies',
  'sidebar.documents': 'Documents',
  'sidebar.invoices': 'Invoices',
  'sidebar.users': 'Users',
  'sidebar.calls': 'Received Calls',
  'sidebar.callsAdmin': 'Phone calls',
  'sidebar.contacts': 'Contact form',
  'sidebar.notifications': 'Notifications',
  'sidebar.tasks': 'Tasks',
  'sidebar.taskRequests': 'Requests',
  'admin.tab.dashboard': 'Overview',
  'admin.tab.companies': 'Companies',
  'admin.tab.documents': 'Documents',
  'admin.tab.invoices': 'Invoices',
  'admin.tab.users': 'Users',
  'admin.tab.tasks': 'Tasks',
  'admin.tab.calls': 'Phone Calls',
  'admin.tab.contacts': 'Contact form',
  'admin.contacts.title': 'Contact form inquiries',
  'admin.contacts.subtitle': 'inquiries',
  'admin.contacts.newBadge': 'new',
  'admin.contacts.unreadBadge': 'unread',
  'admin.contacts.refresh': 'Refresh',
  'admin.contacts.loading': 'Loading…',
  'admin.contacts.empty': 'No inquiries yet.',
  'admin.contacts.loadError': 'Could not load inquiries.',
  'admin.contacts.updateError': 'Could not save.',
  'admin.contacts.statusSaved': 'Status saved.',
  'admin.contacts.noteSaved': 'Note saved.',
  'admin.contacts.col.date': 'Date',
  'admin.contacts.col.contact': 'Contact',
  'admin.contacts.col.office': 'Office',
  'admin.contacts.col.services': 'Services',
  'admin.contacts.col.status': 'Status',
  'admin.contacts.col.notes': 'Internal note',
  'admin.contacts.affiliate': 'Affiliate',
  'admin.contacts.notePlaceholder': 'Next step, agreement…',
  'admin.contacts.saveNote': 'Save note',
  'admin.contacts.openMessage': 'Message',
  'admin.contacts.close': 'Close',
  'admin.contacts.status.new': 'New',
  'admin.contacts.status.contacted': 'Contacted',
  'admin.contacts.status.no_show_negotiations': 'No show in negotiations',
  'admin.contacts.status.in_discussion': 'In discussion',
  'admin.contacts.status.became_client': 'Became a client',
  'admin.contacts.status.declined': 'Declined',
  'admin.contacts.status.spam': 'Spam',
  'admin.cancel': 'Cancel',
  'admin.filters.title': 'Filters',
  'admin.filters.company': 'Company',
  'admin.filters.allCompanies': 'All companies',
  'admin.filters.category': 'Document type',
  'admin.filters.allCategories': 'All types',
  'admin.filters.status': 'Status',
  'admin.filters.allStatuses': 'All statuses',
  'admin.filters.dateFrom': 'From',
  'admin.filters.dateTo': 'To',
  'admin.filters.priority': 'Priority',
  'admin.filters.allPriorities': 'All',
  'admin.filters.reset': 'Clear',
  'admin.users.title': 'User Management',
  'admin.users.total': 'users',
  'admin.users.addUser': 'Add User',
  'admin.users.newUser': 'New User',
  'admin.users.fullName': 'Full Name',
  'admin.users.email': 'Email',
  'admin.users.password': 'Password',
  'admin.users.roleClient': 'Client',
  'admin.users.roleOperator': 'Operator',
  'admin.users.roleAdmin': 'Admin',
  'admin.users.operatorCannotEditAdmin': 'Operators cannot edit administrator accounts.',
  'admin.users.operatorCannotAssignAdmin': 'Operators cannot assign the Administrator role.',
  'admin.users.noCompany': 'No company assigned',
  'admin.users.create': 'Create User',
  'admin.users.creating': 'Creating...',
  'admin.users.created': 'User created',
  'admin.users.createFailed': 'Failed to create user',
  'admin.users.fillRequired': 'Please fill in all required fields',
  'admin.users.passwordMin': 'Password must be at least 8 characters',
  'admin.users.loading': 'Loading users...',
  'admin.users.noUsers': 'No users found',
  'admin.users.name': 'Name',
  'admin.users.emailCol': 'Email',
  'admin.users.roleCol': 'Role',
  'admin.users.companyCol': 'Company',
  'admin.users.assignCompany': 'Assign Company',
  'admin.users.none': 'None',
  'admin.users.assigned': 'Company assigned',
  'admin.users.assignFailed': 'Failed to assign company',
  'admin.users.actions': 'Actions',
  'admin.users.edit': 'Edit',
  'admin.users.resetPassword': 'Reset password',
  'admin.users.editUser': 'Edit user',
  'admin.users.saveChanges': 'Save changes',
  'admin.users.updated': 'User updated',
  'admin.users.updateFailed': 'Could not update user',
  'admin.users.activeUser': 'Active account',
  'admin.users.resetPasswordTitle': 'Set new password',
  'admin.users.newPassword': 'New password',
  'admin.users.confirmPassword': 'Confirm password',
  'admin.users.passwordMismatch': 'Passwords do not match',
  'admin.users.passwordChanged': 'Password has been reset',
  'admin.users.passwordChangeFailed': 'Could not reset password',
  'admin.users.serverConfig':
    'Add SUPABASE_SERVICE_ROLE_KEY to the server environment to enable password reset from the panel.',
  'admin.calls.title': 'Phone Calls',
  'admin.calls.recent': 'recent calls logged',
  'admin.calls.addCall': 'Log call',
  'admin.calls.newCall': 'New call',
  'admin.calls.selectCompany': 'Company *',
  'admin.calls.caller': 'Caller',
  'admin.calls.callerPhone': 'Caller number',
  'admin.calls.reason': 'Reason for call',
  'admin.calls.priority.low': 'Low',
  'admin.calls.priority.medium': 'Medium',
  'admin.calls.priority.high': 'High',
  'admin.calls.duration': 'Duration (minutes, optional)',
  'admin.calls.notes': 'Notes',
  'admin.calls.handledBy': 'Handled by',
  'admin.calls.recording': 'Call recording (optional)',
  'admin.calls.recordingHint': 'Click to attach audio (MP3, WAV, M4A…)',
  'admin.calls.save': 'Save call',
  'admin.calls.saving': 'Saving...',
  'admin.calls.saved': 'Call saved',
  'admin.calls.saveFailed': 'Could not save call',
  'admin.calls.fillRequired': 'Company, caller, phone number and reason are required',
  'admin.calls.loading': 'Loading...',
  'admin.calls.noCalls': 'No calls logged yet',
  'admin.calls.deleted': 'Call deleted',
  'admin.calls.deleteFailed': 'Could not delete call',
  'admin.calls.openRecording': 'Play recording',
  'admin.calls.storageFailed': 'Recording upload failed',
  'admin.calls.delete': 'Delete call',
  'admin.docs.title': 'Document Management',
  'admin.docs.recent': 'recent documents',
  'admin.docs.addDoc': 'Add Document',
  'admin.docs.newDoc': 'New Document',
  'admin.docs.selectCompany': 'Select company *',
  'admin.docs.docName': 'Document name',
  'admin.docs.description': 'Document description',
  'admin.docs.uploadPdf': 'Upload PDF file',
  'admin.docs.category': 'Category',
  'admin.docs.fileUrl': 'File URL (optional)',
  'admin.docs.fileSize': 'File size (e.g. 284 KB)',
  'admin.docs.save': 'Save Document',
  'admin.docs.saving': 'Saving...',
  'admin.docs.uploaded': 'Document added',
  'admin.docs.uploadFailed': 'Failed to add document',
  'admin.docs.fillRequired': 'Company and document name are required',
  'admin.docs.operatorNoInvoiceCategory': 'Operators cannot upload documents in the Invoices category.',
  'admin.docs.loading': 'Loading documents...',
  'admin.docs.noDocs': 'No documents yet',
  'admin.docs.deleted': 'Document deleted',
  'admin.docs.deleteFailed': 'Failed to delete document',
  'admin.docs.storageUploadFailed': 'File upload to storage failed',
  'admin.docs.open': 'Open',
  'admin.docs.noFile': 'No file is stored for this record.',
  'admin.docs.openFailed': 'Could not open file.',
  'admin.docs.deleteFileFailed': 'Could not delete file from storage',
  'admin.docs.cat.company': 'Company Documents',
  'admin.docs.cat.archive': 'Archive Book',
  'admin.docs.cat.mail': 'Incoming Mail',
  'admin.docs.cat.tax': 'Tax Inbox',
  'admin.docs.cat.registration': 'Registration',
  'admin.docs.cat.lease': 'Lease',
  'admin.docs.cat.accounting': 'Accounting',
  'admin.docs.cat.other': 'Other',

  'docCat.CompanyLegal': 'Legal & company registry (APR, articles, resolutions)',
  'docCat.StatutoryArchive': 'Statutory archive & mandatory retention',
  'docCat.MailForwarding': 'Mail & forwarding (scans, incoming post)',
  'docCat.TaxCompliance': 'Taxes, contributions & filings',
  'docCat.ContractsLeases': 'Contracts & leases',
  'docCat.VirtualOfficeServices': 'Virtual office services',
  'docCat.Accounting': 'Accounting & financial statements',
  'docCat.Invoices': 'Invoices',
  'docCat.Other': 'Other',
  'admin.invoices.title': 'Invoice Management',
  'admin.invoices.recent': 'recent invoices',
  'admin.invoices.issue': 'Issue Invoice',
  'admin.invoices.newInvoice': 'New Invoice',
  'admin.invoices.selectCompany': 'Select company *',
  'admin.invoices.description': 'Description',
  'admin.invoices.amount': 'Amount',
  'admin.invoices.dueDate': 'Due Date',
  'admin.invoices.create': 'Create Invoice',
  'admin.invoices.creating': 'Creating...',
  'admin.invoices.created': 'Invoice created',
  'admin.invoices.createFailed': 'Failed to create invoice',
  'admin.invoices.fillRequired': 'Please fill in all required fields',
  'admin.invoices.loading': 'Loading invoices...',
  'admin.invoices.noInvoices': 'No invoices yet',
  'admin.invoices.number': 'Invoice No.',
  'admin.invoices.companyCol': 'Company',
  'admin.invoices.descCol': 'Description',
  'admin.invoices.amountCol': 'Amount',
  'admin.invoices.statusCol': 'Status',
  'admin.invoices.markedPaid': 'Marked as paid',
  'admin.invoices.updateFailed': 'Failed to update invoice',
  'admin.invoices.deleted': 'Invoice deleted',
  'admin.invoices.deleteFailed': 'Failed to delete invoice',
  'admin.invoices.invoiceNumberLabel': 'Invoice number (manual)',
  'admin.invoices.issueDate': 'Issue date',
  'admin.invoices.attachmentLabel': 'Invoice attachment (PDF or image)',
  'admin.invoices.attachmentHint': 'Clients will see this file in their portal under documents.',
  'admin.invoices.chooseFile': 'Choose file',
  'admin.invoices.uploadingDoc': 'Uploading attachment...',
  'admin.invoices.duplicateNumber': 'This invoice number already exists. Use a different number.',
  'admin.invoices.documentUploadFailed': 'Invoice was created but the attachment upload failed',
  'admin.invoices.statusUpdated': 'Invoice status updated',
  'admin.invoices.changeStatus': 'Change status',
  'admin.invoices.deleteInvoice': 'Delete invoice',
  'admin.invoices.stPending': 'Pending',
  'admin.invoices.stPaid': 'Paid',
  'admin.invoices.stOverdue': 'Overdue',
  'admin.invoices.stCancelled': 'Cancelled',
  'admin.invoices.loadFailed': 'Failed to load invoices',
  'admin.invoices.orphanTitle': 'Documents without an invoice record',
  'admin.invoices.orphanHint': 'These PDFs exist under Documents but are not registered as invoices. Register them here to manage status and show them in the invoice list.',
  'admin.invoices.registerFromDocument': 'Register as invoice',
  'admin.invoices.registerConfirm': 'Save invoice',
  'admin.invoices.registeredFromDocument': 'Invoice registered and linked to document',
  'admin.invoices.linkDocumentFailed': 'Invoice was created but linking the document failed',
  'admin.invoices.editInvoice': 'Edit invoice',
  'admin.invoices.saveChanges': 'Save changes',
  'admin.invoices.saving': 'Saving...',
  'admin.invoices.updated': 'Invoice updated',
  'admin.companies.businessAddress': 'Business Address',
  'admin.companies.taxAddress': 'Tax Address / Separate Business Unit',
  'admin.companies.accountManager': 'Account Manager',
  'admin.companies.accountManagerEmail': 'Manager Email',
  'admin.companies.accountManagerPhone': 'Manager Phone',
  'admin.companies.phone': 'Company Phone',
  'admin.companies.email': 'Company Email',
  'admin.companies.regNumber': 'Registration Number',
  'admin.companies.notes': 'Notes',
  'admin.companies.sectionCompany': 'Company',
  'admin.companies.sectionManager': 'Account manager',
  'admin.companies.companyName': 'Company name',
  'admin.companies.country': 'Country',
  'admin.companies.registrationAddress': 'Address and city of registration',
  'admin.companies.aprEmail': 'Official email for APR',
  'admin.companies.aprPhone': 'Official phone for APR',
  'admin.companies.ownerPhone': "Owner's direct phone",
  'admin.companies.ownerEmail': "Owner's direct email",
  'admin.companies.pib': 'Tax ID (PIB)',
  'admin.companies.companyRegistrationDate': 'Company registration date',
  'admin.companies.portalRegistrationDate': 'Portal registration date',
  'admin.companies.managerName': 'Manager name',
  'admin.companies.managerEmail': 'Manager email',
  'admin.companies.managerContactPhone': 'Contact phone',
  'admin.tasks.title': 'Requests',
  'admin.tasks.noTasks': 'No requests',
  'admin.tasks.pending': 'Pending',
  'admin.tasks.submitted': 'Submitted',
  'admin.tasks.ticketUrlPlaceholder': 'https://... accountant ticket link',
  'admin.tasks.saveUrl': 'Save link',
  'admin.tasks.openTicket': 'Open ticket',
  'admin.tasks.urlSaved': 'Link saved.',
  'admin.tasks.urlSaveFailed': 'Failed to save link.',
  'admin.tasks.targetAccountant': 'Accountant',
  'admin.tasks.targetSupport': 'Support',
  'admin.tasks.urgency': 'Urgency',
  'admin.tasks.contactPref': 'Contact',
  'admin.tasks.tabAccountant': 'Accountant',
  'admin.tasks.tabSupport': 'Support',
  'admin.tasks.emptyAccountant': 'No accountant requests yet.',
  'admin.tasks.emptySupport': 'No support requests yet.',
  'admin.tasks.supportStatusReceived': 'Received',
  'admin.tasks.supportStatusInProgress': 'In progress',
  'admin.tasks.supportStatusCompleted': 'Completed',
  'admin.tasks.supportStatusLabel': 'Status',
  'admin.tasks.supportStatusSaved': 'Status updated.',
  'admin.tasks.supportStatusSaveFailed': 'Could not update status.',
  'client.docs.title': 'Company Documents',
  'client.docs.statsLine': '{{count}} documents · {{new}} new',
  'client.docs.search': 'Search documents...',
  'client.docs.all': 'All categories',
  'client.docs.dateFrom': 'From date',
  'client.docs.dateTo': 'To date',
  'client.docs.clearDates': 'Clear dates',
  'client.docs.noResults': 'No documents found',
  'client.docs.adjustSearch': 'Try adjusting your search or filter',
  'client.docs.download': 'Download',
  'client.docs.preview': 'Preview',
  'client.docs.noFile': 'File not available.',
  'client.docs.openFailed': 'Could not open file.',
  'client.docs.invoiceBadge': 'Invoice',
  'client.docs.loading': 'Loading documents...',
  'client.docs.loadFailed': 'Could not load documents.',
  'client.docs.uploadTitle': 'Upload a document',
  'client.docs.uploadHint': 'Upload a file related to your company. PDF, images, and common office formats are supported.',
  'client.docs.docNamePlaceholder': 'Document name (optional)',
  'client.docs.chooseFile': 'Choose file',
  'client.docs.uploading': 'Uploading...',
  'client.docs.submitUpload': 'Submit document',
  'client.docs.uploaded': 'Document uploaded',
  'client.docs.uploadFailed': 'Upload failed',
  'client.docs.fillRequired': 'Please choose a file.',
  'client.invoices.title': 'Invoices & Payments',
  'client.company.address': 'Business Address',
  'client.company.taxAddress': 'Tax Address / Sep. Business Unit',
  'client.company.fieldNotSet': 'Not set',
  'client.company.country': 'Country',
  'client.company.registrationAddress': 'Address and city of registration',
  'client.company.companyEmail': 'Company email',
  'client.company.aprEmail': 'Official APR email',
  'client.company.aprPhone': 'Official APR phone',
  'client.company.ownerPhone': "Owner's phone",
  'client.company.ownerEmail': "Owner's email",
  'client.company.pib': 'Tax ID (PIB)',
  'client.company.notesCompany': 'Notes',
  'client.company.companyRegDate': 'Company registration date',
  'client.company.portalRegDate': 'Portal registration date',
  'client.company.start': 'Service Start',
  'client.company.renewal': 'Next Renewal',
  'client.company.plan': 'Plan',
  'client.company.manager': 'Your Account Manager',
  'client.company.noCompany': 'No company assigned to your account.',
  'client.company.contactManager': 'Contact your account manager for assistance.',
  'company.plan.group.vo': 'Virtual Office',
  'company.plan.group.cw': 'Coworking',
  'company.plan.vo_starter': 'Starter',
  'company.plan.vo_business': 'Business',
  'company.plan.vo_premium': 'Premium',
  'company.plan.cw_hot_desk': 'Hot desk',
  'company.plan.cw_fixed_desk': 'Fixed desk',
  'company.plan.cw_private_office': 'Private office',
  'client.kpi.docs': 'Total Documents',
  'client.kpi.invoices': 'Active Invoices',
  'client.kpi.overdue': 'Overdue Invoices',
  'client.kpi.renewal': 'Next Renewal',
  'client.kpi.docsSub': '{{count}} new this month',
  'client.kpi.invoicesSub': '{{count}} pending payment',
  'client.kpi.overdueSubOk': 'All invoices current',
  'client.kpi.overdueSubAction': 'Action required',
  'client.kpi.renewalValueDays': '{{count}} days',
  'client.kpi.renewalDue': 'Due: {{date}}',
  'client.kpi.renewalSubNone': 'No renewal set',
  'client.calls.title': 'Received Calls',
  'client.calls.caller': 'Caller',
  'client.calls.phone': 'Phone',
  'client.calls.date': 'Date & Time',
  'client.calls.duration': 'Duration',
  'client.calls.notes': 'Notes',
  'client.calls.noCalls': 'No received calls',
  'client.calls.minutes': 'min',
  'client.calls.reason': 'Reason',
  'client.calls.priorityLow': 'Low priority',
  'client.calls.priorityMedium': 'Medium priority',
  'client.calls.priorityHigh': 'High priority',
  'client.calls.openRecording': 'Listen to recording',
  'client.calls.openRecordingFailed': 'Could not open recording',
  'client.task.button': 'Send Request to Accountant',
  'client.task.title': 'New Request for Accountant',
  'client.task.subtitle': 'Describe what you need. Open the reference price list when needed.',
  'client.task.taskTitle': 'Request Title',
  'client.task.taskDesc': 'Request Description',
  'client.task.send': 'Send Request',
  'client.task.sending': 'Sending...',
  'client.task.sent': 'Request sent!',
  'client.task.failed': 'Failed to send request',
  'client.task.fillRequired': 'Request title is required',
  'client.task.pricing': 'Service Pricing',
  'client.task.pricingInfo': 'Pricing Information',
  'client.task.selectServiceLabel': 'Service from price list',
  'client.task.selectServicePlaceholder': 'Select a service (fills title and description)',
  'client.task.lblCategory': 'Category',
  'client.task.lblService': 'Service',
  'client.task.lblPriceRsd': 'Price (clients, RSD)',
  'client.task.lblUnit': 'Unit',
  'client.task.autoDescFooter': 'Add deadline, special requests, or questions below.',
  'client.task.fullPricingOnSite': 'View full price list on the website',
  'client.support.title': 'Contact support',
  'client.support.subtitle': 'Describe your issue. We will get back to you as soon as possible.',
  'client.support.fieldTitle': 'Title',
  'client.support.fieldMessage': 'Message',
  'client.support.urgency': 'Urgency',
  'client.support.urgencyLow': 'Low',
  'client.support.urgencyMedium': 'Medium',
  'client.support.urgencyHigh': 'High',
  'client.support.contactPref': 'How should we contact you?',
  'client.support.contactEmail': 'Email',
  'client.support.contactPhone': 'Phone',
  'client.support.contactBoth': 'Email or phone',
  'client.support.send': 'Send',
  'client.support.sending': 'Sending...',
  'client.support.sent': 'Your message was sent.',
  'client.support.failed': 'Could not send. Please try again.',
  'client.support.fillTitle': 'Title is required.',
  'client.support.fillMessage': 'Message is required.',
  'client.taskRequests.title': 'Requests',
  'client.taskRequests.loading': 'Loading requests...',
  'client.taskRequests.noTasks': 'No requests submitted yet',
  'client.taskRequests.pending': 'Pending',
  'client.taskRequests.submitted': 'Submitted',
  'client.taskRequests.createdAt': 'Created',
  'client.taskRequests.submittedAt': 'Submitted to accountant',
  'client.taskRequests.openTicket': 'Open ticket',
  'client.taskRequests.waitingForTicket': 'Waiting for admin to add the ticket link',
  'client.taskRequests.targetAccountant': 'Accountant',
  'client.taskRequests.targetSupport': 'Support',
  'client.taskRequests.urgency': 'Urgency',
  'client.taskRequests.contactPref': 'Contact',
  'client.taskRequests.tabAccountant': 'Accountant',
  'client.taskRequests.tabSupport': 'Support',
  'client.taskRequests.emptyAccountant': 'No accountant requests yet.',
  'client.taskRequests.emptySupport': 'No support requests yet.',
  'client.taskRequests.supportStatusReceived': 'Received',
  'client.taskRequests.supportStatusInProgress': 'In progress',
  'client.taskRequests.supportStatusCompleted': 'Completed',
  'client.taskRequests.updatedAt': 'Updated',
  'login.title': 'Sign In',
  'login.subtitle': 'Client portal',
  'login.desc': 'Enter your credentials to access the portal',
  'login.email': 'Email Address',
  'login.password': 'Password',
  'login.signIn': 'Sign In',
  'login.signingIn': 'Signing in...',
  'login.fillRequired': 'Please enter your email and password',
  'login.invalidCredentials': 'Invalid email or password',
  'login.forgotPassword': 'Forgot password',
  'login.forgotTitle': 'Reset password',
  'login.forgotDesc': 'Enter your account email address. We will send you a link to set a new password.',
  'login.sendResetLink': 'Send link',
  'login.sendingReset': 'Sending…',
  'login.resetSent': 'If an account exists, check your email for password reset instructions.',
  'login.resetEmailRequired': 'Please enter your email address.',
  'login.resetFailed': 'Could not send email. Please try again.',
  'login.backToSignIn': 'Back to sign in',
  'login.resetLoading': 'Loading…',
  'login.resetPasswordTitle': 'New password',
  'login.resetPasswordDesc': 'Enter a new password for your account.',
  'login.newPassword': 'New password',
  'login.confirmPassword': 'Confirm password',
  'login.passwordMismatch': 'Passwords do not match.',
  'login.passwordTooShort': 'Password must be at least 6 characters.',
  'login.saveNewPassword': 'Save password',
  'login.savingPassword': 'Saving…',
  'login.passwordUpdated': 'Your password has been updated.',
  'login.redirectingToLogin': 'Redirecting you to sign in…',
  'login.resetInvalid': 'This reset link is invalid or has expired. Request a new one from the login page.',
  'admin.companies.addNew': 'Add new company',
  'admin.companies.save': 'Save company',
  'admin.companies.saveChanges': 'Save changes',
  'admin.companies.edit': 'Edit company',
  'admin.companies.editTitle': 'Edit company',
  'admin.companies.editDrawerHint': 'Update the fields below, then save.',
  'admin.companies.view': 'View',
  'admin.companies.delete': 'Delete',
  'admin.companies.edit2': 'Edit',
  'admin.companies.noMatch': 'No companies match your search',
  'admin.companies.loading': 'Loading companies...',
  'admin.companies.taxLabel': 'Tax',
  'admin.companies.colName': 'Company',
  'admin.companies.colCountry': 'Country',
  'admin.companies.colPlan': 'Plan',
  'admin.companies.colStatus': 'Status',
  'admin.companies.detailBadge': 'Company',
  'admin.companies.sectionInfo': 'Company information',
  'admin.companies.sectionDocuments': 'Documents',
  'admin.companies.sectionFinance': 'Finance & invoices',
  'admin.companies.financeTotalPaid': 'Total paid (all time)',
  'admin.companies.financePaidCount': 'Paid invoices',
  'admin.companies.financePending': 'Pending payment',
  'admin.companies.financeOverdue': 'Overdue',
  'admin.companies.detailNoDocuments': 'No documents for this company yet.',
  'admin.companies.recentInvoices': 'Recent invoices',
  'admin.companies.openDoc': 'Open',
  'admin.companies.detailLoading': 'Loading…',
  'admin.companies.serviceStart': 'Service start',
  'admin.companies.nextRenewal': 'Next renewal',
  'admin.companies.searchPlaceholder': 'Search companies...',
  'admin.companies.countOf': 'of',
  'admin.companies.companiesWord': 'companies',
  'admin.companies.addShort': 'Add',
  'admin.companies.refreshTitle': 'Refresh',
  'admin.companies.filterAll': 'All',
  'admin.companies.statusActive': 'Active',
  'admin.companies.statusPending': 'Pending',
  'admin.companies.statusSuspended': 'Suspended',
  'admin.companies.statusArchived': 'Archived',
  'admin.revenue.title': 'Monthly Revenue',
  'admin.revenue.subtitle': 'Last 12 months · paid invoices',
  'admin.revenue.totalLabel': 'Total (12m):',
  'admin.revenue.invoices': 'invoices',
  'admin.quick.title': 'Quick Actions',
  'admin.quick.uploadDoc': 'Upload Document',
  'admin.quick.uploadDocDesc': 'Add docs to a company',
  'admin.quick.addCompany': 'Add Company',
  'admin.quick.addCompanyDesc': 'Onboard new client',
  'admin.quick.issueInvoice': 'Issue Invoice',
  'admin.quick.issueInvoiceDesc': 'Create new invoice',
  'admin.quick.addUser': 'Add User',
  'admin.quick.addUserDesc': 'Assign portal access',
  'admin.quick.addCall': 'Add call',
  'admin.quick.addCallDesc': 'Log an incoming call',
  'admin.quick.generateReport': 'Generate Report',
  'admin.quick.generateReportDesc': 'Export company report',
  'admin.quick.portalSettings': 'Portal Settings',
  'admin.quick.portalSettingsDesc': 'Manage portal config',
  'admin.quick.pendingTasks': 'Pending Tasks',
  'admin.quick.noTasks': 'No pending tasks',
  'admin.quick.portalHealth': 'Portal Health',
  'admin.quick.docCoverage': 'Document coverage',
  'admin.quick.collectionRate': 'Invoice collection rate',
  'admin.quick.activeCompanies': 'Active companies',
  'admin.activity.title': 'Recent Activity',
  'admin.activity.subtitle': 'Live portal activity feed',
  'admin.activity.viewAll': 'View full activity log',
  'admin.activity.noActivity': 'No recent activity',
  'admin.activity.docUploaded': 'Document uploaded for',
  'admin.activity.invoiceOverdue': 'Invoice overdue -',
  'admin.activity.paymentReceived': 'Payment received -',
  'admin.activity.invoiceIssued': 'Invoice issued -',
  'admin.activity.newPending': 'New company pending approval',
  'admin.activity.newOnboarded': 'New company onboarded',
  'admin.activity.contactForm': 'New message from contact form',
  'admin.kpi.activeCompanies': 'Active Companies',
  'admin.kpi.currentlyActive': 'Currently active',
  'admin.kpi.pendingDocs': 'Pending Documents',
  'admin.kpi.awaitingUpload': 'Awaiting upload',
  'admin.kpi.outstandingInvoices': 'Outstanding Invoices',
  'admin.kpi.pendingPayment': 'Pending payment',
  'admin.kpi.overdueInvoices': 'Overdue Invoices',
  'admin.kpi.actionRequired': 'Action required',
  'admin.kpi.revenue': 'Revenue -',
  'admin.kpi.paidThisMonth': 'Paid invoices this month',
  'admin.kpi.newCompanies': 'New Companies (30d)',
  'admin.kpi.onboardedThisMonth': 'Onboarded this month',
  'admin.kpi.urgent': 'URGENT',
  'admin.kpi.contactForm': 'Contact form',
  'admin.kpi.contactFormSub': 'Total inquiries from the site',
  'admin.kpi.contactFormUnread': 'Unread contact inquiries',
  'admin.kpi.contactFormUnreadSub': 'Not yet opened in the panel',
  'client.notif.document': 'New document:',
  'client.notif.invoiceIssued': 'Invoice:',
  'client.notif.invoicePaid': 'Paid invoice:',
  'client.notif.task': 'Request',
  'client.notif.call': 'Call',
  'client.invoices.loading': 'Loading invoices...',
  'client.invoices.noInvoices': 'No invoices found',
  'client.invoices.pending': 'pending payment',
  'client.invoices.viewAll': 'View All',
  'client.invoices.colInvoice': 'Invoice',
  'client.invoices.colDesc': 'Description',
  'client.invoices.colIssued': 'Issued',
  'client.invoices.colDue': 'Due Date',
  'client.invoices.colAmount': 'Amount',
  'client.invoices.colStatus': 'Status',
  'client.invoices.view': 'View invoice',
  'client.invoices.downloadAttachment': 'Download attached file',
  'client.invoices.openAttachment': 'Open attached file',
  'client.invoices.noAttachment': 'No file attached to this invoice.',
  'client.invoices.openFailed': 'Could not open the file.',
  'client.invoices.downloadedOk': 'File for invoice {{n}} opened',
  'portal.languageHint': 'Change language in the top menu',
  'portal.emailLanguage': 'Email notification language',
  'portal.emailLanguageHint':
    'Transactional emails from the portal (invoices, team documents, calls, overdue reminders) use this language.',
  'portal.emailLanguageSaved': 'Email language saved.',

  // VirtualOfficeSection
  'vo.sectionTitle': 'A Serbian Business Address,\nWithout the Office Overhead',
  'vo.sectionDesc': 'Establish a credible, legally registered Serbian business presence from day one - minus the cost and commitment of physical office space.',
  'vo.benefit1.title': 'Prime Belgrade Address',
  'vo.benefit1.desc': 'Topčiderska Street, Savski venac municipality - a business zone in protected greenery, close to central Belgrade.',
  'vo.benefit2.title': 'Mail Handling & Forwarding',
  'vo.benefit2.desc': 'We receive, scan, and forward your business correspondence to wherever you are.',
  'vo.benefit3.title': 'Registration Support',
  'vo.benefit3.desc': 'We assist with APR company registration, providing the required address documentation.',
  'vo.benefit4.title': 'Foreign Company Ready',
  'vo.benefit4.desc': 'Ideal for international companies that need a legal Serbian presence without physical relocation.',
  'vo.benefit5.title': 'Legally Compliant',
  'vo.benefit5.desc': 'Fully compliant with Serbian commercial law and APR registration requirements.',
  'vo.benefit6.title': 'Active Within 48h',
  'vo.benefit6.desc': 'Your address and portal access are ready within two business days of signing.',
  'vo.legalHighlight':
    'We are the only provider in Serbia offering a 100% legal virtual office, fully aligned with every law of the Republic of Serbia.',
  'vo.whoFor': 'Who Is It For',
  'vo.whoFor1': 'Foreign companies entering the Serbian market',
  'vo.whoFor2': 'E-commerce businesses requiring a Serbian VAT address',
  'vo.whoFor3': 'Freelancers and consultants needing a professional business address',
  'vo.whoFor4': 'Companies downsizing from physical office space',
  'vo.whoFor5': 'Startups requiring a registered address before hiring staff',
  'vo.plansTitle': 'Virtual office package',
  'vo.plansDesc':
    'One package covers everything listed below. You choose the address and tax office to match your business and tax priorities.',
  'vo.requestQuote': 'Request a quote',
  'vo.pack.title': 'Virtual office',
  'vo.pack.tagline': 'One price, one package - address, mail and portal.',
  'vo.pack.priceRsd': '3,500 RSD',
  'vo.pack.priceEur': '~30 EUR',
  'vo.pack.annualNote': '2 months free when you pay annually',
  'vo.pack.f1': 'Business address in Belgrade or Kovin (Pančevo tax office); Loznica coming soon, express interest',
  'vo.pack.f2': 'Email notification when mail arrives',
  'vo.pack.f3': 'Incoming mail scanned, sent by email and uploaded to your client portal',
  'vo.pack.f4': 'Receipt into a shared mailbox',
  'vo.pack.f5': 'Dedicated binder for your documentation',
  'vo.pack.f6': 'Discounts on coworking space and meeting rooms',
  'vo.pack.f7': 'Access to the digital portal to track your documentation',

  'vo.addOns.tag': 'ADD-ON SERVICES',
  'vo.addOns.title': 'Extra services with your virtual office',
  'vo.addOns.subtitle': 'Extend your package as needed: clear items and fixed pricing where we can quote it.',
  'vo.addOns.1.title': 'Phone answering service',
  'vo.addOns.1.desc':
    'We take calls on your behalf. You can register our number with the APR; we process every call and notify you who called.',
  'vo.addOns.1.price': '+500 RSD / month',
  'vo.addOns.2.title': 'Document review & tax advice',
  'vo.addOns.2.desc': 'Our legal team can explain any document type at a preferential rate.',
  'vo.addOns.2.price': 'On request',
  'vo.addOns.3.title': 'Environmental (EKO) fee filing',
  'vo.addOns.3.desc': 'We file the municipal environmental fee in the municipalities where we operate.',
  'vo.addOns.3.price': '3,000 RSD / filing',
  'vo.addOns.4.title': 'Dedicated mailbox & name plate',
  'vo.addOns.4.desc':
    'Stand out with your own mailbox and name plate. Box size 370 × 250 × 90 mm.',
  'vo.addOns.4.price': '+1,000 RSD / month',
  'vo.addOns.5.title': 'Meeting room',
  'vo.addOns.5.desc': 'Book a meeting room at our premises at promotional rates.',
  'vo.addOns.5.price': 'On request',
  'vo.addOns.6.title': 'Physical mail forwarding',
  'vo.addOns.6.desc':
    'One letter or several shipments: we send by express or registered mail on your instruction.',
  'vo.addOns.6.price': '+500 RSD + PTT',

  'vo.extraBenefits.tag': 'VIRTUAL OFFICE',
  'vo.extraBenefits.title': 'Virtual office benefits',
  'vo.extraBenefits.desc': 'Additional advantages your company gains with a registered business address.',
  'vo.extraBenefits.1.title': 'Protection of your business address',
  'vo.extraBenefits.1.desc':
    'Your registered address stays consistent and clearly reflected in the APR registry, with professional handling of correspondence so your business address is protected from misuse.',
  'vo.extraBenefits.2.title': 'Protection of your phone number',
  'vo.extraBenefits.2.desc':
    'Business contact can be routed through our address so private numbers and personal details stay separate from your public business profile.',
  'vo.extraBenefits.3.title': 'One of Belgrade’s more favourable tax zones',
  'vo.extraBenefits.3.desc':
    'A location in a zone that ranks among the more favourable in the city, which can support lower overall operating and tax-related costs.',
  'vo.extraBenefits.4.title': 'Mailbox and nameplate always at the address',
  'vo.extraBenefits.4.desc':
    'A physical mailbox and company nameplate are always present on site, helping avoid returned mail and issues with inspections that require proper signage and mail reception at the address.',
  'vo.extraBenefits.5.title': 'Mail archiving and the ledger book',
  'vo.extraBenefits.5.desc':
    'Incoming mail is logged and archived according to the rules, with secure storage for maintaining and keeping the ledger book.',
  'vo.extraBenefits.6.title': 'Receiving the tax inspector',
  'vo.extraBenefits.6.desc':
    'An authorised person is always available to receive the tax inspector and provide the required documentation on site.',

  'pausalBanner.text':
    'Our office is in a protected green zone, Savski venac municipality. We also offer a registered address in Kovin (Pančevo tax office). The Loznica location is coming soon; express interest for this option.',
  'pausalBanner.button': 'Tax calculator (eTax)',
  'pausalBanner.textInlineLink':
    'See whether your activity can be taxed on a flat-rate (lump-sum) basis on this page.',
  'pausalBanner.aria': 'Flat-rate tax – link to the Tax Administration calculator',

  // CoworkingSection
  'cw.sectionTitle': 'A Professional Workspace\nin the Heart of Belgrade',
  'cw.sectionDesc': 'Designed for productivity and collaboration. Work alongside other professionals in a clean, quiet, business-focused environment - not a noisy café.',
  'cw.amenity1': 'Gigabit Internet',
  'cw.amenity1.desc': '1 Gbps fiber',
  'cw.amenity2': 'Coffee & Kitchen',
  'cw.amenity2.desc': 'Fully stocked',
  'cw.amenity3': 'Dual Monitor Setup',
  'cw.amenity3.desc': 'On request',
  'cw.amenity4': 'Meeting Rooms',
  'cw.amenity4.desc': '3 available',
  'cw.amenity5': 'Flexible Booking',
  'cw.amenity5.desc': 'Day or month',
  'cw.amenity6': '24h Secure Access',
  'cw.amenity6.desc': 'Key card entry',
  'cw.plan.hotDesk.desc': 'Flexible open desk, available any weekday. Perfect for freelancers and part-time workers.',
  'cw.plan.hotDesk.f1': 'Any available desk',
  'cw.plan.hotDesk.f2': 'Weekday access',
  'cw.plan.hotDesk.f3': 'Locker storage',
  'cw.plan.hotDesk.f4': 'Meeting room credits (2h/mo)',
  'cw.plan.dedicated.desc': 'Your own reserved desk, locked storage, and a permanent workspace in our coworking area.',
  'cw.plan.dedicated.f1': 'Reserved desk 24/7',
  'cw.plan.dedicated.f2': 'Locked storage cabinet',
  'cw.plan.dedicated.f3': 'Business address add-on available',
  'cw.plan.dedicated.f4': 'Meeting room credits (5h/mo)',
  'cw.plan.private.desc': 'Fully enclosed private office for 1–4 people. Includes lockable storage and dedicated meeting room hours.',
  'cw.plan.private.f1': 'Enclosed private office',
  'cw.plan.private.f2': 'Up to 4 workstations',
  'cw.plan.private.f3': 'Dedicated meeting room (10h/mo)',
  'cw.plan.private.f4': 'Custom branding on door',

  // AccountingSection
  'acc.sectionTitle': 'Professional Business Support\nfor Serbia',
  'acc.sectionDesc': 'A missed Tax Administration deadline, an incorrect VAT return or a non-compliant address can mean penalties and disrupted operations - especially if you do not speak Serbian and do not know the APR rules. Our team works in five languages, takes over that complexity and tracks the deadlines for you, so you can focus on your business.',
  'acc.svc1.title': 'Bookkeeping & Accounting',
  'acc.svc1.desc': 'Monthly bookkeeping, financial statement preparation, and compliance reporting in line with Serbian accounting standards (MSFI/MRS).',
  'acc.svc1.tag1': 'Monthly reports',
  'acc.svc1.tag2': 'MSFI/MRS compliant',
  'acc.svc2.title': 'Tax & VAT (PDV) Registration',
  'acc.svc2.desc': 'We handle your PDV registration, quarterly VAT returns, corporate income tax filing, and all statutory deadlines with the Tax Administration.',
  'acc.svc2.tag1': 'PDV registration',
  'acc.svc2.tag2': 'Quarterly returns',
  'acc.svc3.title': 'Legal Document Support',
  'acc.svc3.desc': 'Preparation and review of contracts, employment agreements, and business documents - drafted to comply with Serbian commercial and labor law.',
  'acc.svc3.tag1': 'Contract drafting',
  'acc.svc3.tag2': 'Labor law',
  'acc.svc4.title': 'Multilingual Advisory',
  'acc.svc4.desc': 'Our team provides consultations in Serbian, English, Russian, Turkish, and German - ensuring clear communication for international clients.',
  'acc.svc4.tag1': '5 languages',
  'acc.svc4.tag2': 'International clients',
  'acc.stat1.label': 'Years of Experience',
  'acc.stat1.sub': 'in Serbian business law',
  'acc.stat2.label': 'Clients Supported',
  'acc.stat2.sub': 'local and international',
  'acc.stat3.label': 'Languages',
  'acc.stat3.sub': 'consultation languages',
  'acc.stat4.label': 'Tax Returns Filed',
  'acc.stat4.sub': 'since 2014',
  'acc.cta.title': 'Book a Free Consultation',
  'acc.cta.desc': 'Speak with one of our accounting or legal advisors about your specific business situation. Available in Serbian, English, Russian, Turkish, and German.',
  'acc.cta.btn': 'Schedule a Call',
  'acc.pricing.show': 'Show pricing',
  'acc.pricing.hide': 'Hide pricing',
  'acc.pricing.footer': 'All prices are in Serbian Dinars (RSD). Minimum prices, subject to agreement. ✓ indicates services that can be provided fully online.',

  // TrustSection
  'trust.statsTitle': 'Trusted by companies around the world',
  'trust.stat1': 'Companies Registered',
  'trust.stat2': 'Documents Managed',
  'trust.stat3': 'Years in Business',
  'trust.stat4': 'Countries Served',
  'trust.trustedBy': 'Trusted by companies from across Europe and beyond',
  'trust.testimonialsTag': 'Client Testimonials',
  'trust.testimonialsTitle': 'What Our Clients Say',
  'trust.test1.text':
    'We needed a Serbian business address to expand our EU operations. Top14 office solutions covered everything: registration, documents, and mail forwarding. The client portal makes it incredibly easy.',
  'trust.test1.highlight': 'Registered in under 48 hours',
  'trust.test2.text':
    'As a Russian entrepreneur, I needed a trustworthy partner in Serbia. Top14 provided multilingual support; PDV registration and the whole process were seamless from start to finish.',
  'trust.test2.highlight': 'Multilingual support made the difference',
  'trust.test3.text':
    'The coworking space is professional and well-equipped. Top14 office solutions are my base in Belgrade when I am in Serbia: great internet, a calm space, and a team that is always helpful.',
  'trust.test3.highlight': 'My go-to Belgrade workspace',

  'partners.tag': 'Partners',
  'partners.title': 'Our partners',
  'partners.desc':
    'Teams that extend the Top14 ecosystem: digital presence, finance, AI, and education.',
  'partners.evi.name': 'EVI Solutions',
  'partners.evi.desc':
    'A strong web presence is often the first step to credible operations. Beyond that, EVI builds full portals, e‑commerce, and applications, with professional IT operations so your digital layer stays reliable as you scale.',
  'partners.tim011.name': 'Tim011 Digital',
  'partners.tim011.desc':
    'A partner for launching a sole proprietorship or company quickly, with emphasis on speed and online accounting. Reliable day‑to‑day support and clearer tax positioning, so you run the business, not the paperwork.',
  'partners.intrascope.name': 'Intrascope',
  'partners.intrascope.desc':
    'One AI workspace for your company: leading models in one place, shared context, and control inside the team. Use promo code TOP150 for USD 150 off your first annual plan purchase.',
  'partners.capitaale.name': 'Capitaale',
  'partners.capitaale.desc':
    'Capitaale is an app for entrepreneurs who invoice clients abroad. Real RSD balance after the bank rate, live flat-tax limit tracking, a warning when one client exceeds 70% of revenue, and an invoice in EUR or USD in 60 seconds. First 7 days free.',

  // Footer hardcoded items
  'footer.businessAddress': 'Business Address',
  'footer.legalAssistance': 'Legal Assistance',
  'footer.companyRegistration': 'Company Registration',

  // Blog
  'blog.subtitle': 'Guides on virtual offices, company formation, and business addresses in Belgrade and Serbia.',
  'blog.readMore': 'Read more',
  'blog.backToBlog': 'Back to blog',
  'blog.related': 'Related articles',
  'blog.published': 'Published',
  'blog.minRead': 'min read',
  'blog.ctaTitle': 'Ready for a virtual office in Belgrade?',
  'blog.ctaDesc': 'Book a consultation and learn how Top14 can support your business in Serbia.',
  'blog.ctaBtn': 'Contact',
  'blog.authorTeam': 'Top14 Team',
  'blog.sources': 'Useful links',
  'blog.breadcrumbHome': 'Home',
};

export default en;
